<template>
	<div class="supplier-sales">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Sales</h1>
				<div class="page-header-right text-right ml-a">
				</div>
			</div>
			<div class="page-content mt-4">
				<!-- Table Menu -->
				<div class="table-list-menu" v-if="isAdminOnly">
					<div class="row">
						<div class="col-sm-6">
							<div class="input-group">
								<!-- Search Supplier -->
								<multiselect v-model="salesChanged" :show-labels="false" class="form-control"
									track-by="_id" label="label" placeholder="Username / Email" :options=optionSales
									@search-change="fetchDataSales">
									<span slot="noResult">
										No options matching the query
									</span>
									<span slot="noOptions">
										No options available
									</span>
								</multiselect>
								<span>
									<button @click="showModal('delete')" class="btn ml-2" :class="{'btn-outline-danger': selectedSales.length > 0, 'btn-default': selectedSales.length === 0}" :disabled="selectedSales.length === 0"><span
											class="bi bi-trash mr-2"></span>Delete</button>
								</span>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="table-filters d-flex align-items-center justify-content-end ml-a">
								<!-- Clear Filter -->
								<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
									{{ $t('Clear Filter') }}
								</button>
								<button type="button" class="btn btn-sm btn-light" @click="showModal('bulk_assign')">
									<i class="bi bi-box-arrow-up"></i>
									<span class="mr-2">Bulk Assign</span>
								</button>
								<button type="button" class="btn btn-sm btn-primary" @click="showModal('create')">
									<i class="bi bi-plus"></i>
									<span class="mr-2">Add Sales</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="user-sales-list table-responsive">
					<table class="user-sales-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th v-if="isAdminOnly" width="5%" class="th-checkbox">
									<label class="input-checkbox-container">
										<input type="checkbox" class="input-checkbox" v-model="selectAll">
										<span></span>
									</label>
								</th>
								<th width="25%" class="text-left">
									ID Sales
								</th>
								<th width="20%" class="th-sort text-left" :class="sortClass('name')"
									@click="changeSorting('name')">
									Nama
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('email')"
									@click="changeSorting('email')">
									Email
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('seller_count')"
									@click="changeSorting('seller_count')">
									Jumlah Seller
								</th>
								<th width="20%" v-if="isAdminOnly">
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="(item, index) in items">
								<tr :key="index">
									<td v-if="isAdminOnly">
										<label class="input-checkbox-container">
											<input type="checkbox" class="input-checkbox" :value="item" v-model="selectedSales" :disabled="deleted === 'all' && item.is_deleted">
											<span></span>
										</label>
									</td>
									<td>
										<span @click="copyId(item._id)" role="button">
											{{ item._id }}
										</span>
									</td>
									<td>
										<div class="name">
											{{ item.name }}
										</div>
									</td>
									<td>
										{{ item.email }}
									</td>
									<td>
										<router-link :to="'/admin/sales/' + item._id">
											{{ countSeller(item) }}
										</router-link>
									</td>
									<td v-if="isAdminOnly">
										<button class="btn btn-sm btn-outline-primary mr-2 mt-2" @click="showModal('assign', item)"><i
												class="bi bi-person-lines-fill mr-2"></i>Assign</button>
										<button class="btn btn-sm btn-outline-danger mt-2" @click="showModal('delete', item)"><i
												class="bi bi-trash mr-2"></i>Delete</button>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Sales Found yet.</span>
						<span v-else>No Sales was found</span>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal Filter -->
		<modal class="table-filter-modal" size="large" v-if="isShowCreateSales" @close="isShowCreateSales = false">
			<div slot="header">
				<h3>Add Sales</h3>
			</div>
			<div slot="body">
				<div class="row">
					<div class="col-6">
						<div class="form-group">
							<label for="">
								Full name
							</label>
							<input type="text" placeholder="Masukan nama lengkap" :class="{'is-invalid' : errorForm.name}" class="form-control" v-model="sales.name">
							<div class="invalid-feedback">
								{{ errorForm.name }}
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form-group">
							<label for="">
								Nick name
							</label>
							<input type="text" placeholder="Masukan Nickname" :class="{'is-invalid' : errorForm.nickname}" class="form-control" v-model="sales.nickname">
							<div class="invalid-feedback">
								{{ errorForm.nickname }}
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div class="form-group">
							<label for="">
								Email
							</label>
							<input type="text" placeholder="Masukan email" :class="{'is-invalid' : errorForm.email}" class="form-control" v-model="sales.email">
							<div class="invalid-feedback" v-if="errorForm.email">
								{{ errorForm.email }}
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form-group">
							<label for="">
								Phone Number
							</label>
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text" id="basic-addon1">+62</span>
								</div>
								<input type="text" name="phone" :class="{'is-invalid' : errorForm.phone}" class="form-control" placeholder="Phone Number"
								v-model.trim="sales.phone" @input="inputPhone" minlength="9" required>
								<div class="invalid-feedback" v-if="errorForm.phone">
									{{ errorForm.phone }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowCreateSales = false">{{ $t('Cancel') }}</button>
				<button type="button" class="btn btn-primary" :class="{'is-loading' : isSaving}" @click="createSales">Save</button>
			</div>
		</modal>

		<!-- Modal Delete -->
		<modal
			class="coupon-editor-modal"
			size="medium"
			@close="isShowDeleteSales = false"
			v-if="isShowDeleteSales">
			<div slot="header">
				<h3>
					<i class="material-icons">delete</i>
					<span class="ml-1">{{ $t('Delete Sales') }}</span>
				</h3>
			</div>
			<div slot="body">
				<p>Are you sure want to delete : </p>
					<div v-for="(item, index) in selectedSales" :key="index">
						<b>{{ index+1+ '. ' + item.name }}</b>
					</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowDeleteSales = false">{{ $t('Cancel') }}</button>
				<button type="button" class="btn btn-danger" :class="{ 'is-loading': isDeleting }" @click="deleteSales">
					<i class="material-icons">delete</i>
					<span>{{ $t('Confirm Delete') }}</span>
				</button>
			</div>
		</modal>

		<!-- Modal Bulk Assign Sales -->
		<modal
			class="coupon-editor-modal"
			size="x-large"
			@close="isShowBulkAssignModal = false"
			v-if="isShowBulkAssignModal">
			<div slot="header">
				<h3>
					<span class="ml-1">{{ $t('Assign Sales') }}</span>
				</h3>
			</div>
			<div slot="body">
				<div class="container">
					<div class="row">
					<div class="col-md-12">
						<!-- Upload Form -->
						<form id="uploadForm" enctype="multipart/form-data">
							<div class="form-group">
								<label for="excelFile">Choose Excel File</label>
								<input
									id="bulk-assign-file"
									type="file"
									class="form-control p-1"
									accept=".xlsx, .xls, .csv">
							</div>
						</form>
						<!-- Download Example Link -->
						<div class="mt-3">
						<p>
							Template excel: <a class="ml-3" href="https://cdn.ostock.id/templates/template_ostock_assign_seller_to_sales_v1.xlsx">Download</a>
						</p>
						</div>
					</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowBulkAssignModal = false">{{ $t('Cancel') }}</button>
				<button type="button" class="btn btn-primary" :class="{ 'is-loading': isAssigningSeller }" @click="bulkAssign">
					<span>{{ $t('Confirm Assign') }}</span>
				</button>
			</div>
		</modal>
		<!-- Modal Assign Sales -->
		<modal
			class="coupon-editor-modal"
			size="x-large"
			@close="isShowAssignModal = false"
			v-if="isShowAssignModal">
			<div slot="header">
				<h3>
					<span class="ml-1">{{ $t('Assign Sales') }}</span>
				</h3>
			</div>
			<div slot="body">
				<div class="loading" v-if="isGettingAssignedSeller">
					<shimmer width="100%" height="80px" class="mb-2"/>
					<div class="row">
						<div class="col-md-6">
							<shimmer width="20%" height="30px" class="mb-2"/>
						</div>
						<div class="col-md-6 d-flex align-items-center justify-content-end ">
							<shimmer width="30%" height="30px" class="mb-2"/>
						</div>
					</div>
					<shimmer width="100%" height="300px" class="mb-2"/>
				</div>
				<div class="assign-seller" v-else>
					<div class="sales-info px-3">
						<div class="row well d-flex justify-content-between align-items-center">
							<div class="col-md-1">
								<span class="icon-sales text-primary">
									<i class="bi bi-person-lines-fill mr-2"></i>
								</span>
							</div>
							<div class="col-md-7">
								<div class="sales-name">{{sales.name}}</div>
								<div class="email-style">{{ sales.email }}</div>
							</div>
							<div class="col-md-4">
								<div class="total-label">Total</div>
								<div class="fs-16 text-primary text-bold">{{ assignedSeller.length }}</div>
							</div>
						</div>
					</div>
					<div class="row mt-4">
							<div class="col-sm-7 text-bold fs-16">
								Data Seller
							</div>
							<div class="col-sm-5">
								<div class="table-filters d-flex align-items-center justify-content-end ml-a">
									<!-- Search Supplier -->
									<multiselect v-model="selectedSeller" :show-labels="false" class="form-control"
										track-by="_id" label="label" placeholder="Username / Email Seller" :options=optionSeller
										:loading="isSearchingSeller && searchSeller !== ''" @search-change="fetchDataSeller">
										<span slot="noResult">
											No options matching the query
										</span>
										<span slot="noOptions">
											No options available
										</span>
									</multiselect>
								</div>
							</div>
					</div>
					<div class="search-result well bg-search"  v-if="assignedSeller.length > 0">
						<div class="row clear-result">
							<div class="col-md-12 text-right">
								<button class="btn btn-default" @click="clearAllAssignedSeller" v-if="assignedSeller.length > 0"> Clear All</button>
							</div>
						</div>
						<div class="row item-result">
							<div class="col-md-4 mt-3" v-for="(item,index) in assignedSeller" :key="'seller-'+index">
								<div class="card-result well">
									<div class="row d-flex justify-content-between align-items-center">
										<div class="col-md-10">
											<div class="name">
												{{item.name}}
											</div>
											<div class="email-style">
												<span class="fs-12">
													<i class="bi bi-envelope-fill"></i>
												</span>
												{{ item.email }}
											</div>
										</div>
										<div class="col-md-2 text-right">
											<span role="button" @click="removeAssignedSeller(item)">
												<i class="fa fa-times"></i>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="list-empty  bg-search" v-if="assignedSeller.length === 0 && isGettingAssignedSeller === false">
						<i class="material-icons mr-2">error_outline</i>
						<span>No Seller was found</span>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowAssignModal = false">{{ $t('Cancel') }}</button>
				<button type="button" class="btn btn-primary" :class="{ 'is-loading': isAssigningSeller }" @click="assignSales">
					<span>{{ $t('Confirm Assign') }}</span>
				</button>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
	formatDate,
	copyToClipboard,
	isValidEmail,
	duplicateVar,
} from '@/lib/helper';
import adminApi from '@/api/admin';
import modal from '@/components/Modal.vue';
import shimmer from '@/components/Shimmer.vue';
import { defaultSalesField } from '@/lib/statics';

export default {
	name: 'AdminSales',
	components: {
		modal,
		shimmer,
	},
	data() {
		return {
			limit: 25,
			sort_by: 'created_at',
			sort: 'desc',
			isSearchingSupplier: false,
			isSaving: false,
			isDeleting: false,
			isShowCreateSales: false,
			isShowDeleteSales: false,
			isShowAssignModal: false,
			isShowBulkAssignModal: false,
			isAssigningSeller: false,
			isGettingAssignedSeller: false,
			deleted: false,
			optionSupplier: [],
			keyword: null,
			selectedSales: [],
			deletedSeller: [],
			sales: duplicateVar(defaultSalesField),
			selectall: false,
			errorForm: {
				name: '',
				email: '',
				nickname: '',
				phone: '',
			},
			searchSales: null,
			optionSales: [],
			isSearchingSales: false,
			searchSeller: null,
			assignedSeller: [],
			optionSeller: [],
			isSearchingSeller: false,
			selectedSeller: null,
			salesChanged: null,
		};
	},
	methods: {
		...mapActions({
			getSales: 'sales/getSales',
			resetSales: 'sales/resetSales',
			setActiveSales: 'sales/setActiveSales',
			setUnshiftSales: 'sales/setUnshiftSales',
		}),
		duplicateVar,
		countSeller(sales) {
			let count = 0;

			if (sales.seller_count) {
				count = sales.seller_count;
			}

			return count;
		},
		showModal(type, sales = null) {
			switch (type) {
			case 'create':
				this.isShowCreateSales = true;
				break;
			case 'delete':
				if (sales) {
					this.selectedSales = [sales];
				}
				this.isShowDeleteSales = true;
				break;
			case 'assign':
				if (sales) {
					this.sales = sales;
				}
				this.getAssignedSeller();
				this.isShowAssignModal = true;
				break;
			case 'bulk_assign':
				this.isShowBulkAssignModal = true;
				break;
			default:
				break;
			}
		},
		createSales() {
			this.validateAllForm();
			const isErrorExist = Object.values(this.errorForm).find(val => val !== '');
			if (isErrorExist) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Periksa kembali form',
				});
				return;
			}

			this.isSaving = true;
			const params = {
				sales: JSON.stringify(this.sales),
			};

			const callback = (response) => {
				this.isSaving = false;
				const notify = {
					group: 'app',
					title: 'Create Sales',
					text: response?.message ?? 'Succesfully created Sales',
					type: 'success',
				};

				if (response.error_code === 400) {
					notify.type = 'error';
					this.$notify(notify);
				} else {
					this.$notify(notify);
					this.setUnshiftSales(response.data);
					this.resetForm();
					this.isShowCreateSales = false;
				}
			};
			const errorCallback = (response) => {
				this.isSaving = false;
				this.$notify({
					group: 'app',
					title: 'Create Sales',
					text: response?.message ?? 'Failed to create sales',
					type: 'error',
				});
			};

			adminApi.createSales(params, callback, errorCallback);
		},
		deleteSales() {
			this.isDeleting = true;
			const params = {
				selected_sales: this.selectedSales,
			};

			const callback = (response) => {
				this.isDeleting = false;
				this.isShowDeleteSales = false;
				this.fetchItems(true);
				this.$notify({
					group: 'app',
					title: 'Sales',
					text: response?.message ?? 'succesfully deleted Sales',
					type: 'success',
				});
				this.resetForm();
			};
			const errorCallback = (response) => {
				this.isDeleting = false;
				this.$notify({
					group: 'app',
					title: 'Sales',
					text: response?.message ?? 'error when deleting data',
					type: 'error',
				});
			};

			adminApi.deleteSales(params, callback, errorCallback);
		},
		fetchDataSales(query) {
			this.isSearchingSales = true;

			const params = {
				keyword: query,
				role: 'sales',
			};

			const callback = (response) => {
				this.optionSales = response.data;
				this.isSearchingSales = false;
			};
			const errorCallback = () => {
				this.isSearchingSales = false;
			};

			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		formatDate,
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			if (this.salesChanged) {
				params.sales_id = this.salesChanged._id;
			}

			return params;
		},
		fetchItems(clear = false) {
			if (clear) {
				this.resetSales();
			}
			const params = this.getFetchParams();
			this.getSales(params);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		applyFilter() {
			this.fetchItems(true);
		},
		resetForm() {
			this.sales = duplicateVar(defaultSalesField);
			this.selectedSales = [];
		},
		clearFilter() {
			this.salesChanged = null;
			this.applyFilter();
		},
		fetchDataSeller(query) {
			this.isSearchingSeller = true;
			const params = {
				keyword: query,
				role: 'owner',
				owner_type: 'dropshipper',
			};
			const callback = (response) => {
				this.optionSeller = response.data;
				this.isSearchingSeller = false;
			};
			const errorCallback = () => {
				this.isSearchingSeller = false;
			};
			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		clearAllAssignedSeller() {
			this.deletedSeller = this.assignedSeller.map(seller => seller._id);
			this.assignedSeller = [];
		},
		assignSales() {
			this.isAssigningSeller = true;
			const sellerId = this.assignedSeller.map(seller => seller._id);
			const params = {
				seller_ids: JSON.stringify(sellerId),
				deleted_seller_ids: JSON.stringify(this.deletedSeller),
				sales_id: this.sales._id,
			};
			const callback = (response) => {
				this.isAssigningSeller = false;
				this.isShowAssignModal = false;

				this.$notify({
					group: 'app',
					title: 'Seller Assign',
					text: response?.message ?? 'Successfully assign Seller',
					type: 'success',
				});

				this.fetchItems(true);
			};
			const errorCallback = (response) => {
				this.isAssigningSeller = false;
				this.$notify({
					group: 'app',
					title: 'Seller Assign',
					text: response?.message ?? 'Failed assign Seller',
					type: 'error',
				});
			};

			adminApi.assignSales(params, callback, errorCallback);
		},
		getAssignedSeller() {
			this.isGettingAssignedSeller = true;
			const params = {
				sales_id: this.sales._id,
			};

			const callback = (response) => {
				this.assignedSeller = response.data;
				this.isGettingAssignedSeller = false;
			};
			const errorCallback = () => {
				this.isGettingAssignedSeller = false;
			};

			adminApi.getAssignedSeller(params, callback, errorCallback);
		},
		copyId(item) {
			copyToClipboard(item);
			// toast notification
			this.$notify({
				group: 'app',
				title: 'ID Copied',
				text: item,
				type: 'success',
			});
		},
		removeAssignedSeller(item) {
			this.deletedSeller.push(item._id);
			this.assignedSeller = this.assignedSeller.filter(seller => seller._id !== item._id);
		},
		fullNameValidation() {
			this.errorForm.name = '';
			if (this.sales.name === '') {
				this.errorForm.name = 'Full Name wajib diisi';
			}
		},
		nickNameValidation() {
			this.errorForm.nickname = '';
			if (this.sales.nickname === '') {
				this.errorForm.nickname = 'Nickname wajib diisi';
			}
		},
		emailValidation() {
			this.errorForm.email = '';
			if (this.sales.email === '') {
				this.errorForm.email = 'Email wajib diisi';
			} else if (!isValidEmail(this.sales.email)) {
				this.errorForm.email = 'Format email belum sesuai';
			}
		},
		phoneValidation() {
			this.errorForm.phone = '';
			if (this.sales.phone === '') {
				this.errorForm.phone = 'Phone wajib diisi';
			} else if (this.sales.phone.length <= 9) {
				this.errorForm.phone = 'Phone minimal memiliki 9 karakter';
			}
		},
		validateAllForm() {
			this.fullNameValidation();
			this.nickNameValidation();
			this.emailValidation();
			this.phoneValidation();
		},
		inputPhone() {
			const validPhone = this.isPhoneError();
			this.sales.phone = this.sales.phone.replace(/[^\d]/g, '');
			if (validPhone) {
				// this.isValidateError.phone = false;
				const firstSelection = this.sales.phone.substring(0, 1);
				const secondSelection = this.sales.phone.substring(0, 2);
				let phone = this.sales.phone;
				if (secondSelection === '62') {
					phone = phone.replace('62', '');
				} else if (firstSelection === '0') {
					phone = phone.replace('0', '');
				}
				this.sales.phone = phone;
			}
		},
		isPhoneError() {
			return (
				this.sales.phone.trim() !== ''
				&& !new RegExp(/^\+\d+$/).test(this.sales.phone.trim())
			);
		},
		bulkAssign() {
			const bulkAssignInput = document.querySelector('input#bulk-assign-file'); // Menggunakan querySelector untuk mencari input dengan id bulk-assign-file
			if (bulkAssignInput) { // Memastikan input ditemukan
				const files = bulkAssignInput.files;
				if (files.length > 0) {
					const file = files[0];
					this.isAssigningSeller = true;
					const formData = new FormData();
					formData.append('file', file);
					const callback = (response) => {
						this.isAssigningSeller = false;
						this.isShowBulkAssignModal = false;
						this.$notify({
							group: 'app',
							title: 'Bulk Assign',
							text: response?.message ?? 'Successfully assign seller',
							type: 'success',
						});
						this.fetchItems(true);
					};
					const errorCallback = (response) => {
						this.isShowBulkAssignModal = false;
						this.isAssigningSeller = false;
						this.$notify({
							group: 'app',
							title: 'Bulk Assign',
							text: response?.message ?? 'Failed to assign seller',
							type: 'error',
						});
					};
					adminApi.bulkAssign(formData, callback, errorCallback);
				}
			}
		},

	},
	computed: {
		...mapGetters({
			items: 'sales/allSales',
			isFetching: 'sales/isFetching',
			isAll: 'sales/isAll',
			page: 'sales/page',
			isFetched: 'sales/isFetched',
			activeSales: 'sales/activeSales',
			isRoleSuperAdmin: 'isRoleSuperAdmin',
			isRoleAdmin: 'isRoleAdmin',
		}),
		isFilterOn() {
			return this.salesChanged !== null;
		},
		selectAll: {
			get() {
				return this.items ? this.selectedSales.length === this.items.length : false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.items.forEach((sales) => {
						if (this.deleted === 'all') {
							if (!sales.is_deleted) {
								selected.push(sales);
							}
						} else {
							selected.push(sales);
						}
					});
				}
				this.selectedSales = selected;
			},
		},
		isAdminOnly() {
			const isAdmin = this.isRoleAdmin || this.isRoleSuperAdmin;

			return isAdmin;
		},
	},
	watch: {
		selectedSeller() {
			const isExist = this.assignedSeller.find(assigned => assigned._id === this.selectedSeller._id);
			if (this.selectedSeller != null && !isExist) {
				this.deletedSeller = this.deletedSeller.filter(deleted => deleted !== this.selectedSeller._id);
				this.assignedSeller.unshift(this.selectedSeller);
			}
		},
		assignedSeller() {
			this.selectedSeller = null;
			this.searchSeller = '';
			this.isSearchingSeller = false;
		},
		salesChanged() {
			this.resetSales();
			this.setActiveSales(this.salesChanged);
			this.fetchItems();
		},
		activeSales() {
			this.salesChanged = this.activeSales;
		},
	},
	created() {
		if (this.activeSales !== null) {
			this.salesChanged = this.activeSales;
		}
		this.resetSales();
		this.fetchItems();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
.icon-sales {
	font-size: 40px;
}
.fs-16 {
	font-size: 16px;
}
.fs-12 {
	font-size: 12px;
}
.sales-name {
	font-size: 14px;
	font-weight: 500;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
	color: #2E323D;
}
.email-style {
	font-size: 14px;
	font-weight: 400;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
	color: #80848E;
}

.bg-search {
	border-radius: 5px;
	margin-top: 10px;
	background-color: rgba(244, 250, 255, 1);
	height: 300px;
	overflow-y: scroll;
}
</style>
